// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"0ce47644","605":"77ed1939","809":"62452d41","981":"517effe4"}[chunkId] + ".chunk.js";
};